"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ZoomOut() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/_react.default.createElement("g", {
    fill: _BaseTheme.default.colors.gray
  }, /*#__PURE__*/_react.default.createElement("path", {
    transform: "translate(1 1)",
    d: "M13.2-1C5.368-1-1 5.369-1 13.2c0 7.83 6.369 14.2 14.2 14.2 7.83 0 14.2-6.37 14.2-14.2C27.4 5.368 21.03-1 13.2-1zm0 2c6.749 0 12.2 5.45 12.2 12.2 0 6.749-5.451 12.2-12.2 12.2C6.45 25.4 1 19.95 1 13.2 1 6.45 6.45 1 13.2 1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    transform: "translate(1 1)",
    d: "M22.744 21.8a1 1 0 00-.65.294 1 1 0 000 1.414l7.199 7.199a1 1 0 001.414 0 1 1 0 000-1.414l-7.2-7.2a1 1 0 00-.763-.292z"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 4.545a1 1 0 00-1 1 1 1 0 001 1h11.088a1 1 0 001-1 1 1 0 00-1-1H0z",
    transform: "translate(1 1) translate(7.2 7.2)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.545-1a1 1 0 00-1 1v11.088a1 1 0 001 1 1 1 0 001-1V0a1 1 0 00-1-1z",
    transform: "translate(1 1) translate(7.2 7.2)"
  }))));
}

var _default = ZoomOut;
exports.default = _default;